export default __webpack_public_path__ + "static/media/FisnishRegistration.e9768270.svg";